/* eslint-disable @typescript-eslint/naming-convention */
/* istanbul ignore file */
import { baseTheme } from '@aircall/tractor';
import { defaultTheme } from '@aircall/tractor-v2';
import { Theme } from '@aircall/tractor/es/styles/theme';
import { ResellerConfig } from '@config/resellers.config';

const { colors: baseColors } = baseTheme;
export const defaultColors = {
  ...baseColors,
};

export const dashboardTheme = {
  ...baseTheme,
  colors: { ...defaultColors, ...(ResellerConfig?.theme?.v1 || {}) },
} as unknown as Theme;

const defaultColorsV2 = defaultTheme.colors;

export const dashboardThemeV2 = {
  ...defaultTheme,
  colors: {
    // custom color palette
    ...defaultColorsV2,
  },
};
